import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ClientsList from "./clients-list/clients-list";
import CasesList from "./case-list/case-list";
import { useActiveCases } from "../../hooks/useActiveCases";
import { Link } from "react-router-dom";

const TABS = ["cases", "closed", "clients"];
const TAB_LABELS = ["Active Cases", "Closed Cases", "Clients"];

const IconPlus = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M7 1v12M1 7h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
const IconSearch = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.4" />
    <path d="M9.5 9.5L13 13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

function ArchivePage() {
  const { kind } = useParams();
  const navigate = useNavigate();
  const activeCases = useActiveCases();
  const [query, setQuery] = useState("");

  const selectedIndex = useMemo(() => TABS.indexOf(kind || ""), [kind]);

  return (
    <div className="p-content">
      <div className="p-pagehead">
        <div>
          <div className="p-breadcrumb">Workspace</div>
          <h1 className="p-pagetitle">{TAB_LABELS[selectedIndex] || "Cases"}</h1>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <Link to="/case-form/new/0" className="p-btn p-btn-primary">
            <IconPlus /> New case
          </Link>
        </div>
      </div>

      <div className="p-card">
        <div className="p-tabs">
          {TABS.map((t, i) => (
            <div
              key={t}
              className={`p-tab${selectedIndex === i ? " active" : ""}`}
              onClick={() => navigate(`/admin/${t}`)}
            >
              {TAB_LABELS[i]}
            </div>
          ))}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "16px 24px", borderBottom: "1px solid var(--line)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "9px 14px", background: "var(--cream)", border: "1px solid var(--line)", borderRadius: 999, fontSize: 13, color: "var(--ink-soft)", flex: "none", width: 300 }}>
            <IconSearch />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search by case # or address…"
              style={{ border: "none", outline: "none", background: "transparent", fontSize: 13, color: "var(--ink)", width: "100%", fontFamily: "var(--sans)" }}
            />
          </div>
        </div>

        {kind === "cases" ? (
          <CasesList query={query} cases={activeCases} />
        ) : kind === "closed" ? (
          <div style={{ padding: "48px 24px", textAlign: "center", color: "var(--ink-soft)", fontSize: 14 }}>
            No closed cases yet.
          </div>
        ) : (
          <ClientsList query={query} />
        )}
      </div>
    </div>
  );
}

export default ArchivePage;
